import { render, staticRenderFns } from "./purchaseData.vue?vue&type=template&id=2f8b2c54&scoped=true"
import script from "./purchaseData.vue?vue&type=script&lang=js"
export * from "./purchaseData.vue?vue&type=script&lang=js"
import style0 from "./purchaseData.vue?vue&type=style&index=0&id=2f8b2c54&prod&scoped=true&lang=css"
import style1 from "./purchaseData.vue?vue&type=style&index=1&id=2f8b2c54&prod&scoped=true&lang=css"
import style2 from "./purchaseData.vue?vue&type=style&index=2&id=2f8b2c54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8b2c54",
  null
  
)

export default component.exports